import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, IndexRoute, hashHistory } from "react-router";

import "semantic-ui/dist/semantic.min.css";
import "./index.css";

import App from "./App";
import About from "./modules/About";
import CaseStudy from "./modules/CaseStudy";
import Recommendations from "./modules/Recommendations";
import Examples from "./modules/Examples";

ReactDOM.render(
	<Router history={hashHistory}>
		<Route path="/" component={App}>
			<IndexRoute component={About} />

			<Route path="about-me" component={About} />
			<Route path="case-study" component={CaseStudy} />
			<Route path="recommendations" component={Recommendations} />
			<Route path="links-examples" component={Examples} />
		</Route>
	</Router>,
	document.getElementById( "root" )
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/